import React from "react";
import "../css/LandingNewBanner.css";
import DesktopBannerVideo from "../../assets/withouttinted.mp4";
import MobileBannerVideo from "../../assets/MobVideo.mp4";

export default function LandingNewBanner({
  onCtaClick,
  ctaText = "Claim Your Free Clover POS",
  headlineRight = "",
}) {
  const handleCtaClick = () => {
    if (onCtaClick) {
      onCtaClick();
      return;
    }
    window.location.href = "/apply";
  };

  return (
    <section className="heroBanner" aria-label="Landing banner">
      {/* Desktop background video */}
      <video
        className="heroBanner__video heroBanner__video--desktop"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={DesktopBannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Mobile background video */}
      <video
        className="heroBanner__video heroBanner__video--mobile"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={MobileBannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay for readability */}
      <div className="heroBanner__overlay" />

      {/* Content */}
      <div className="heroBanner__container">
        <div className="heroBanner__content">
          <div className="heroBanner__label">INTRODUCING</div>

          <div className="heroBanner__titleGroup">
            <div className="heroBanner__stat" aria-hidden="true">
              <span className="heroBanner__statNumber">Free <br></br>Clover POS</span>
              <span className="heroBanner__statPercent"></span>
            </div>

            <h1 className="heroBanner__title">
              {headlineRight.split("\n").map((line, index) => (
                <span key={index} className="heroBanner__titleLine">
                  {line}
                </span>
              ))}
            </h1>
          </div>

          <p className="heroBanner__subtitle">
           0% Credit Card Processing Fees Available in All 50 States.
          </p>

          <ul className="heroBanner__features">
            <li className="heroBanner__featureItem">
               Collect 100% of your processing sales
            </li>
            <li className="heroBanner__featureItem">
              NO Transaction Fees | NO Junk Fees!
            </li>
            <li className="heroBanner__featureItem">
              100% legal. Available in all 50 states
            </li>
            <li className="heroBanner__featureItem">
              Eliminate processing fees
            </li>
            <li className="heroBanner__featureItem">
              Next day funding
            </li>
            <li className="heroBanner__featureItem">
              No Upfront Costs
            </li>
          </ul>

          <div className="heroBanner__actions">
            <button
              className="heroBanner__button"
              type="button"
              onClick={handleCtaClick}
            >
              {ctaText}
            </button>

            <span className="heroBanner__note">No Obligation</span>
          </div>
        </div>
      </div>
    </section>
  );
}